export const buildURL = ({language, regionID, productID, offset, index}, prefix) => (
    ['', language, regionID, prefix, productID, offset, index, ''].map(String).join('/')
);
